import React, { Component } from 'react';
import { Link } from "react-router-dom";
import Layout from '../Layout';
import BlogPostsHero from '../../presentational/Heros/BlogPosts';
import Posts from '../../presentational/Blog/Posts';

const posts = 	[
  {
	   ordernum: 1, timeStamp: '29.11.2019', postImage: 'https://via.placeholder.com/1200x300', title: 'KVKK ya Hazır mısınız?', subtitle: 'KVKK 31.12.2019 da devreye giriyor', avatarUrl: 'https://via.placeholder.com/250x250', author: 'Azerhan Özen', shortContent: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc lacinia euismod urna, in gravida leo efficitur a. Sed tempus augue risus, eget faucibus urna hendrerit a. Donec pulvinar maximus dui ut porttitor. Nullam tristique tortor et ipsum tristique, ac lacinia diam faucibus. Nunc cursus massa eget consectetur laoreet ...', likeCount: 32, commentCount: 0
	},
  {
	   ordernum: 2, timeStamp: '29.11.2019', postImage: 'https://via.placeholder.com/1200x300', title: 'KVKK ya Hazır mısınız?', subtitle: 'KVKK 31.12.2019 da devreye giriyor', avatarUrl: 'https://via.placeholder.com/250x250', author: 'Azerhan Özen', shortContent: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc lacinia euismod urna, in gravida leo efficitur a. Sed tempus augue risus, eget faucibus urna hendrerit a. Donec pulvinar maximus dui ut porttitor. Nullam tristique tortor et ipsum tristique, ac lacinia diam faucibus. Nunc cursus massa eget consectetur laoreet ...', likeCount: 32, commentCount: 0
	},
  {
	   ordernum: 3, timeStamp: '29.11.2019', postImage: 'https://via.placeholder.com/1200x300', title: 'KVKK ya Hazır mısınız?', subtitle: 'KVKK 31.12.2019 da devreye giriyor', avatarUrl: 'https://via.placeholder.com/250x250', author: 'Azerhan Özen', shortContent: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc lacinia euismod urna, in gravida leo efficitur a. Sed tempus augue risus, eget faucibus urna hendrerit a. Donec pulvinar maximus dui ut porttitor. Nullam tristique tortor et ipsum tristique, ac lacinia diam faucibus. Nunc cursus massa eget consectetur laoreet ...', likeCount: 32, commentCount: 0
	},
  {
	   ordernum: 4, timeStamp: '29.11.2019', postImage: 'https://via.placeholder.com/1200x300', title: 'KVKK ya Hazır mısınız?', subtitle: 'KVKK 31.12.2019 da devreye giriyor', avatarUrl: 'https://via.placeholder.com/250x250', author: 'Azerhan Özen', shortContent: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc lacinia euismod urna, in gravida leo efficitur a. Sed tempus augue risus, eget faucibus urna hendrerit a. Donec pulvinar maximus dui ut porttitor. Nullam tristique tortor et ipsum tristique, ac lacinia diam faucibus. Nunc cursus massa eget consectetur laoreet ...', likeCount: 32, commentCount: 0
	}];

const recentPosts = [
  { url: '/BlogPost/12', title: '7 Adımda Maliyet', avatarUrl: 'https://via.placeholder.com/250x250', timeStamp: 'Ekim 2019' },
  { url: '/BlogPost/13', title: 'Yılbaşı geçiş CheckList', avatarUrl: 'https://via.placeholder.com/250x250', timeStamp: 'Eylül 2019' }
];
let comments = [
  {avatarUrl: 'https://via.placeholder.com/250x250', author: 'Tuba Gülle', url: '/BlogPost/12', title: 'ERP de İnsan Faktörü'},
  {avatarUrl: 'https://via.placeholder.com/250x250', author: 'Tuba Gülle', url: '/BlogPost/12', title: 'ERP de İnsan Faktörü'},
  {avatarUrl: 'https://via.placeholder.com/250x250', author: 'Tuba Gülle', url: '/BlogPost/12', title: 'ERP de İnsan Faktörü'}
];

comments = [];
const archieves = [
  { title: 'Ekim 2019', count: 3, url: '/BlogPosts/201910' },
  { title: 'Eylül 2019', count: 13 , url: '/BlogPosts/201909'},
  { title: 'Ağustos 2019', count: 8 , url: '/BlogPosts/201908'},
];

const categories = [
  { title: 'ERP', count: 3, url: '/BlogPosts/erp' },
  { title: 'Mobil', count: 13, url: '/BlogPosts/mobile' },
  { title: 'MES', count: 8, url: '/BlogPosts/mes' },
  { title: 'CRM', count: 12, url: '/BlogPosts/crm' },
  { title: 'HRM', count: 4, url: '/BlogPosts/hrm' }
];

const tags = [
  { title: 'ERP', url: '/BlogPosts/erp' },
  { title: 'Mobil', url: '/BlogPosts/mobile' },
  { title: 'MES', url: '/BlogPosts/mes' },
  { title: 'CRM', url: '/BlogPosts/crm' },
  { title: 'HRM', url: '/BlogPosts/hrm' }
];

export default class Contact extends Component {
  render() {
    return(
      <Layout mainhero={<BlogPostsHero />}>
        <Posts
          posts={posts}
          recentPosts={recentPosts}
          comments={comments}
          archieves={archieves}
          categories={categories}
          tags={tags}
        />
      </Layout>
    );
  }
};
